module.exports = __webpack_public_path__ + "static/media/image001.2d2d655d.jpg";